// extracted by mini-css-extract-plugin
export default {"quizContainer":"quizContainer__pLNhp","quizImage":"quizImage__HY80J","quizContent":"quizContent__mO8C6"};